/* eslint-disable no-underscore-dangle */
import {put,call,takeLatest} from 'redux-saga/effects';
import { ACCESS_CARD, UPDATE_ACCESS_CARD } from '../action/constant';
import request from '../utils/request';
import { getAccessCardsSuccess,
   getAccessCardsError, updateAccessCardSuccess,
   updateAccessCardError, } from '../action/accessCard';

   const token = localStorage.getItem('token');

function* accessCardSaga(action){
  const data = JSON.parse(localStorage.getItem('building'));
  const url = `Cards/getcards?buildingId=${data._id}&page=${action.data.page || 1}&limit=${action.data.sizePerPage || 10}&search=${action.data.search || ''}`;
  try{
  const response = yield call(request,url,{
    method:'GET',
    headers:{
      Accept:'application/json',
      Authorization:`VMS-2.0${token}`,
    }
  });
  yield put(getAccessCardsSuccess(response.data));
  }
  catch(err){
  yield put(getAccessCardsError(err.response));
  }
}
function* updateAccessSaga(action){
  const url = `Cards/update?id=${action.data.id}`;
  try{
   const response = yield call(request,url,{
     method:'PUT',
     headers:{
       Accept:'application/json',
       Authorization:`VMS-2.0${token}`,
     },
     data:action.data
   });
   yield put(updateAccessCardSuccess(response.data));
  }
 catch(err){
  yield put(updateAccessCardError(err.response));
 }
}
export default function* watcherAccessSaga(){
  yield takeLatest(ACCESS_CARD.PENDING,accessCardSaga);
  yield takeLatest(UPDATE_ACCESS_CARD.PENDING,updateAccessSaga);
}
